import { useMemo } from 'react';
import '../styles/wordOfDay.css';

const WORD_BANK = [
  {
    word: 'Serendipity',
    partOfSpeech: 'noun',
    pronunciation: 'seh·ruhn·DIP·uh·tee',
    meaning: 'The gift of finding valuable or pleasant things that you were not looking for.',
    example: 'Discovering the perfect research article an hour before the deadline felt like pure serendipity.',
    synonyms: ['chance discovery', 'happy accident'],
    root: 'From Serendip, an old name for Sri Lanka; coined by Horace Walpole in 1754.',
  },
  {
    word: 'Meticulous',
    partOfSpeech: 'adjective',
    pronunciation: 'muh·TIH·kyuh·luhs',
    meaning: 'Showing great attention to detail; being very careful and precise.',
    example: 'A meticulous approach to note-taking pays off during finals.',
    synonyms: ['precise', 'thorough'],
    root: 'From Latin metu "fear" — originally meaning fearful of making mistakes.',
  },
  {
    word: 'Resilience',
    partOfSpeech: 'noun',
    pronunciation: 'rih·ZIL·yuhns',
    meaning: 'The capacity to recover quickly from difficulties; mental toughness.',
    example: 'Her resilience after the tough lab exam inspired the whole class.',
    synonyms: ['grit', 'perseverance'],
    root: 'From Latin resilire "to spring back".',
  },
  {
    word: 'Lucid',
    partOfSpeech: 'adjective',
    pronunciation: 'LOO·suhd',
    meaning: 'Expressed clearly; easy to understand.',
    example: 'His lucid explanation made vector calculus feel approachable.',
    synonyms: ['clear', 'coherent'],
    root: 'From Latin lucidus "full of light".',
  },
  {
    word: 'Catalyst',
    partOfSpeech: 'noun',
    pronunciation: 'CAT·uh·list',
    meaning: 'Something that speeds up change or action without being changed itself.',
    example: 'Joining debate club was the catalyst for her confidence on stage.',
    synonyms: ['spark', 'impetus'],
    root: 'From Greek katalyein "to dissolve".',
  },
];

function getDailyWord() {
  const today = new Date();
  const key = `${today.getFullYear()}-${today.getMonth()}-${today.getDate()}`;
  let hash = 0;
  for (let i = 0; i < key.length; i += 1) {
    hash = (hash * 31 + key.charCodeAt(i)) % 2147483647;
  }
  const idx = hash % WORD_BANK.length;
  return WORD_BANK[idx];
}

export default function WordOfDay({ onClose }) {
  const wordData = useMemo(() => getDailyWord(), []);

  return (
    <div
      className="wod-overlay"
      role="dialog"
      aria-modal="true"
      aria-label="Word of the day"
      onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}
    >
      <article className="wod-modal">
        <header className="wod-header">
          <div>
            <p className="wod-eyebrow">Word of the day</p>
            <h2 className="wod-word">
              {wordData.word}
              <span className="wod-pos">{wordData.partOfSpeech}</span>
            </h2>
            <p className="wod-pronunciation">{wordData.pronunciation}</p>
          </div>
          <button type="button" className="wod-close" onClick={onClose} aria-label="Close word of the day panel">
            ✕
          </button>
        </header>

        <section className="wod-body">
          <p className="wod-meaning">{wordData.meaning}</p>
          <p className="wod-example">
            <span className="wod-label">Example:</span> “{wordData.example}”
          </p>
          <div className="wod-meta">
            <div>
              <p className="wod-label">Synonyms</p>
              <p>{wordData.synonyms.join(', ')}</p>
            </div>
            <div>
              <p className="wod-label">Word root</p>
              <p>{wordData.root}</p>
            </div>
          </div>
        </section>
      </article>
    </div>
  );
}
